import { config } from '@/pageConfig/termsOfService/nl/nl';
import { TermsOfServicePageTemplate } from '@/pageTemplate/TermsOfServicePageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function LegalStuffPage() {
  const { trackEvent } = useAnalyticsContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: we just one it on load so no need to add it as a dependency
  useEffect(() => {
    trackEvent('terms_of_service_page.viewed');
  }, []);

  return <TermsOfServicePageTemplate config={config} />;
}
